export function toImageSrc(value?: string | null): string | undefined {
    return value ? `data:image/jpeg;base64,${value}` : undefined;
}

export function base64SizeInBytes(value: string): number {
    return Math.ceil(value.length * 3 / 4);
}
